<script>
	// The params prop contains values matched from the URL
	export let params = {};

	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		TipoEvento, 
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp, 
		TextoFeedback } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let tipo, valor, captchaUsuario;
	let tituloAviso = "Erro";
	let tiposAnexos = [];
	let informacosAPICache = null;

	onMount(async () => {
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		let tiposAnexosProjeto = informacosAPICache.anexos_projeto;
		let tiposAnexosUsuario = informacosAPICache.anexos_usuario;

		if (params.cpf == undefined)
			tiposAnexos = Object.entries(tiposAnexosProjeto);
		else
			tiposAnexos = Object.entries(tiposAnexosUsuario);
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Adicionando ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint adicionar(post), envia os dados e aguarda a resposta
			let endpointAnexo = params.cpf ? API('usuarios/anexos') : API('projetos/anexos');
			let bodyAnexo = params.cpf ? JSON.stringify({
				tipo: tipo,
				valor: valor
			}) : JSON.stringify({
				tipo: tipo,
				valor: valor,
				codigo: params.codigo
			});
			
			const resposta = await fetch(endpointAnexo, {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: bodyAnexo
			}).catch(erros => {
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: TextoFeedback.ERRO_REQUISICAO
				});
			});

			if (resposta.status == StatusHttp.OK) {
				replace('#/painel');
			}

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Tudo certo!',
				conteudo: 'Anexo adicionado.'
			});
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<TBox 
	titulo="Formulário de Anexos" 
	subtitulo="Adicionando novo anexo no cadastro" 
	largura="10" 
	deslocamento="1" 
	correcaoY="-13px"
	icone="anexo">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-12">
				<small class="has-text-primary">Tipo de anexo:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={tipo} name="tipo" required>
						<option value="">Escolha...</option>
						{#each tiposAnexos as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<small class="has-text-primary">Digite o conteúdo para o tipo selecionado:</small>				
				<div class="field">
					<textarea 
						bind:value={valor}
						class="textarea is-primary is-size-5" 
						placeholder="Escreva aqui o contúdo para o tipo de anexo selecionado"
						name="valor"
						required></textarea>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					{#if (params.hasOwnProperty('cpf'))}
					<a href="#/usuario/visualizar/{ params.cpf }" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
					{:else if (params.hasOwnProperty('codigo'))}
					<a href="#/projeto/visualizar/{ params.codigo}" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
					{:else}
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
					{/if}
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Adicionar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>